import { api } from '@cwd/lib/main';
import { JourneyStats, ExecutionHistoryReference, Task, IssueSendOccasionLogItem, IssueSendOccasionRecipientListItem, SmsMessageLogItem, SmsMessageRecipientListItem } from './journeys';

export async function MoveToSent(issueId: string): Promise<void> {
    return api.post(`/Issues/${issueId}/MoveToSent/`);
}

export async function GetIssueSchedule(issueId: string): Promise<Task[]> {
    return api.get(`/Scheduling/${issueId}/Schedules/`);
}

export async function SaveIssueSchedule(issueId: string, schedule: Task): Promise<void> {
    return api.post(`/Scheduling/${issueId}`, schedule);
}

export async function GetJourneyStats(journeyId: string): Promise<JourneyStats> {
    return api.get(`/Journeys/${journeyId}/Stats/`);
}

export async function GetJourneyExecutionHistory(journeyId: string): Promise<ExecutionHistoryReference[]> {
    return api.get(`/journeys/${journeyId}/executionhistory?limit=50`);
}

export interface SendLogParams {
    issueId?: string;
    from?: string;
    to?: string;
}

export async function GetJourneySendLog(journeyId: string, params: SendLogParams = {}): Promise<IssueSendOccasionLogItem[]> {
    const query = new URLSearchParams();
    if (params.issueId) query.set('issueId', params.issueId);
    if (params.from) query.set('from', params.from);
    if (params.to) query.set('to', params.to);
    const qs = query.toString();
    return api.get(`/Journeys/${journeyId}/SendLog${qs ? '?' + qs : ''}`);
}

export async function GetSendOccasionRecipients(issueId: string, occasionId: string): Promise<IssueSendOccasionRecipientListItem[]> {
    return api.get(`/Issues/${issueId}/SendOccasions/${occasionId}/Recipients`);
}

export async function GetJourneySmsLog(journeyId: string): Promise<SmsMessageLogItem[]> {
    return api.get(`/Journeys/${journeyId}/SmsLog`);
}

export async function GetSmsMessageRecipients(smsMessageId: string): Promise<SmsMessageRecipientListItem[]> {
    return api.get(`/Sms/${smsMessageId}/Recipients`);
}
